import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage';

const config = {
  apiKey: process.env.REACT_APP_FB_APIKEY,
  authDomain: process.env.REACT_APP_FB_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_FB_DATABASEURL,
  projectId: process.env.REACT_APP_FB_PROJECTID,
  storageBucket: process.env.REACT_APP_FB_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FB_APPID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENTID
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

let inFlightAuthTokenPromise = null;

const resetAuthTokenCache = () => {
  inFlightAuthTokenPromise = null;
};

const getFirebaseAuthToken = async (forceRefresh = false) => {
  const currentUser = firebase.auth().currentUser;

  if (!currentUser) {
    resetAuthTokenCache();
    return undefined;
  }

  if (!forceRefresh && inFlightAuthTokenPromise) {
    return inFlightAuthTokenPromise;
  }

  inFlightAuthTokenPromise = currentUser
    .getIdToken(forceRefresh)
    .catch((error) => {
      resetAuthTokenCache();
      throw error;
    })
    .finally(() => {
      inFlightAuthTokenPromise = null;
    });

  return inFlightAuthTokenPromise;
};

firebase.auth().onIdTokenChanged(() => {
  resetAuthTokenCache();
});

export { firebase, getFirebaseAuthToken };
